import { render, staticRenderFns } from "./selectSettings.modal.vue?vue&type=template&id=21a834c6"
import script from "./selectSettings.modal.vue?vue&type=script&lang=js"
export * from "./selectSettings.modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports